import {config} from '@onflow/fcl';
import {environment} from '../../environments/environment';

config()
  .put('env', 'local')
  .put('accessNode.api', environment.accessNode)
  .put('discovery.wallet', environment.fclWalletDiscovery)
  .put('challenge.handshake', environment.fclWalletDiscovery)
  .put('0xMainService', environment.fclContractProfile);
